import React, { useEffect, useState } from 'react';
const comparisonRows = [{
  without: 'Buscás actividades en Google sin saber si sirven',
  with: 'Sistema completo listo para aplicar hoy'
}, {
  without: 'No sabés si tu hijo va bien o no',
  with: 'Checklists de hitos claros por mes'
}, {
  without: 'Las alertas las notás tarde o no las notás',
  with: 'Semáforo neurológico por etapa'
}, {
  without: 'Actividades sin orden ni criterio',
  with: '6 tomos secuenciados mes a mes'
}, {
  without: 'Información dispersa y contradictoria',
  with: 'Un sistema validado por profesionales'
}, {
  without: 'Improvisás cada semana sin saber qué hacer',
  with: 'Protocolo de estimulación por área'
}, {
  without: 'Te angustiás sin saber si es normal',
  with: 'Criterio claro para actuar con calma'
}, {
  without: 'El lenguaje y el motor sin guía',
  with: 'Actividades específicas para cada área'
}, {
  without: 'Perdés los primeros 3 años sin aprovecharlos',
  with: 'Máximo potencial en la ventana crítica'
}];
const TIMER_KEY = 'megapack_estimulacion_countdown_end';
const DURATION_MS = 24 * 60 * 60 * 1000;
function getEndTime(): number {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  const stored = localStorage.getItem(TIMER_KEY);
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + DURATION_MS;
  localStorage.setItem(TIMER_KEY, String(end));
  return end;
}
function getTimeLeft(endTime: number) {
  const diff = Math.max(0, endTime - Date.now());
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(diff % (1000 * 60) / 1000);
  return {
    hours,
    minutes,
    seconds
  };
}
export function DarkCTA() {
  const [endTime] = useState<number>(() => getEndTime());
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(endTime));
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft(endTime));
    }, 1000);
    return () => clearInterval(timer);
  }, [endTime]);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-16 sm:py-20 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(243,232,255) 0%, rgb(253,244,255) 15%, rgb(253,244,255) 85%, rgb(243,232,255) 100%)'
  }} data-id="element-86">
      <div className="mx-auto max-w-4xl text-center" data-id="element-87">
        {/* ── BRAND ── */}
        <div className="mb-8 sm:text-3xl font-black tracking-[3px] text-[18px]" style={{
        background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }} data-id="element-88">
          👶 MEGAPACK ESTIMULACIÓN TEMPRANA™
        </div>

        {/* ── HEADLINES ── */}
        <h2 className="text-xl sm:text-3xl font-bold text-gray-900 m-0 mb-3" data-id="element-89">
          La próxima semana podés seguir improvisando.
        </h2>
        <p className="text-xl sm:text-3xl font-black m-0 mb-10" style={{
        background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }} data-id="element-90">
          O podés empezar hoy con un sistema real para los primeros 3 años.
        </p>

        {/* ── COMPARISON TABLE ── */}
        <div className="mx-auto max-w-2xl mb-12 overflow-hidden rounded-2xl text-left shadow-sm" style={{
        border: '1px solid rgba(168,85,247,0.20)'
      }} data-id="element-91">
          {/* Table title */}
          <div className="text-center font-bold text-gray-900 px-4 py-4" style={{
          backgroundColor: 'rgb(243,244,246)',
          borderBottom: '1px solid rgba(168,85,247,0.15)'
        }} data-id="element-92">
            ¿Cuánto cuesta NO tenerlo?
          </div>

          {/* Column headers */}
          <div className="grid grid-cols-2" style={{
          backgroundColor: 'rgb(243,244,246)',
          borderBottom: '1px solid rgba(168,85,247,0.15)'
        }} data-id="element-93">
            <div className="text-center font-bold text-gray-500 px-4 py-3 text-sm" data-id="element-94">
              SIN MEGAPACK
            </div>
            <div className="text-center font-bold px-4 py-3 text-sm" style={{
            color: '#7c3aed',
            borderLeft: '1px solid rgba(168,85,247,0.15)'
          }} data-id="element-95">
              CON MEGAPACK
            </div>
          </div>

          {/* Rows */}
          {comparisonRows.map((row, i) => <div key={i} className="grid grid-cols-2 bg-white" style={{
          borderBottom: i < comparisonRows.length - 1 ? '1px solid rgba(168,85,247,0.08)' : 'none'
        }} data-id="element-96">
              <div className="px-4 py-3 text-xs sm:text-sm text-gray-500" data-id="element-97">
                ✗ {row.without}
              </div>
              <div className="px-4 py-3 text-xs sm:text-sm font-bold text-gray-900" style={{
            backgroundColor: 'rgba(124,58,237,0.04)',
            borderLeft: '1px solid rgba(168,85,247,0.08)'
          }} data-id="element-98">
                ✓ {row.with}
              </div>
            </div>)}
        </div>

        {/* ── COUNTDOWN ── */}
        <div className="mb-4" data-id="element-99">
          <p className="font-bold text-gray-900 m-0 mb-4" data-id="element-100">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-center justify-center gap-0" data-id="element-101">
            <div className="flex flex-col items-center" data-id="element-102">
              <span className="text-5xl sm:text-7xl font-black tabular-nums" style={{
              color: 'rgb(255,68,68)'
            }} data-id="element-103">
                {pad(timeLeft.hours)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-104">
                hs
              </span>
            </div>

            <span className="mb-4 text-5xl sm:text-7xl font-black" style={{
            color: 'rgb(255,68,68)'
          }} data-id="element-105">
              :
            </span>

            <div className="flex flex-col items-center" data-id="element-106">
              <span className="text-5xl sm:text-7xl font-black tabular-nums" style={{
              color: 'rgb(255,68,68)'
            }} data-id="element-107">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-108">
                min
              </span>
            </div>

            <span className="mb-4 text-5xl sm:text-7xl font-black" style={{
            color: 'rgb(255,68,68)'
          }} data-id="element-109">
              :
            </span>

            <div className="flex flex-col items-center" data-id="element-110">
              <span className="text-5xl sm:text-7xl font-black tabular-nums" style={{
              color: 'rgb(255,68,68)'
            }} data-id="element-111">
                {pad(timeLeft.seconds)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-112">
                seg
              </span>
            </div>
          </div>
        </div>

        <p className="text-sm text-gray-600 m-0 mb-12" data-id="element-113">
          Después sube{' '}
          <span className="font-bold text-red-500" data-id="element-114">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* ── PRICING CARDS ── */}
        <div className="mx-auto max-w-2xl mb-10 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-115">
          {/* Standard */}
          <div className="flex flex-col rounded-xl p-6 shadow-sm" style={{
          backgroundColor: 'rgb(255,255,255)',
          border: '1px solid rgba(168,85,247,0.20)'
        }} data-id="element-116">
            <div className="mb-2 text-2xl" data-id="element-117">👶</div>
            <h3 className="text-base font-black text-gray-900 m-0 mb-1" data-id="element-118">
              MEGAPACK ESTIMULACIÓN TEMPRANA
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-119">
              6 Tomos + 6 Bonos · Sistema Completo 0 a 36 meses
            </p>
            <div className="mt-auto" data-id="element-120">
              <p className="text-sm text-gray-500 line-through m-0 mb-1" data-id="element-121">
                Antes: $39.990 ARS
              </p>
              <p className="text-2xl font-black m-0 mb-4" style={{
              color: '#7c3aed'
            }} data-id="element-122">
                Hoy: $19.990 ARS
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48260170875050:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Megapack Estimulación Temprana',
                  content_category: 'Estimulación Temprana',
                  value: 19990,
                  currency: 'ARS'
                });
              }
            }} className="block text-white text-center text-sm font-black rounded-lg py-4 no-underline hover:opacity-90 transition-opacity" style={{
              background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)'
            }} data-id="element-123">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          {/* Pro */}
          <div className="flex flex-col rounded-xl p-6 shadow-sm" style={{
          backgroundColor: 'rgba(124,58,237,0.04)',
          border: '2px solid #7c3aed',
          boxShadow: '0px 0px 30px 0px rgba(124,58,237,0.15)'
        }} data-id="element-124">
            <div className="mb-2 text-2xl" data-id="element-125">🏆</div>
            <h3 className="text-base font-black m-0 mb-1" style={{
            color: '#7c3aed'
          }} data-id="element-126">
              MEGAPACK + NEURODESARROLLO AVANZADO ⭐
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-1" data-id="element-127">La más elegida</p>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-128">
              6 Tomos + 6 Bonos + Protocolo Avanzado
              <br data-id="element-129" />
              (planificación semanal + registro ampliado)
            </p>
            <div className="mt-auto" data-id="element-130">
              <p className="text-sm text-gray-500 line-through m-0 mb-1" data-id="element-131">
                Antes: $54.990 ARS
              </p>
              <p className="text-3xl font-black m-0 mb-4" style={{
              color: '#7c3aed'
            }} data-id="element-132">
                Hoy: $27.990 ARS
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48260172021930:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Megapack + Neurodesarrollo Avanzado',
                  content_category: 'Estimulación Temprana',
                  value: 27990,
                  currency: 'ARS'
                });
              }
            }} className="block text-white text-center text-sm font-black rounded-lg py-4 no-underline hover:opacity-90 transition-opacity" style={{
              background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)'
            }} data-id="element-133">
                → QUIERO EL MEGAPACK COMPLETO
              </a>
            </div>
          </div>
        </div>

        {/* ── TRUST BADGES ── */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-600" data-id="element-134">
          <span data-id="element-135">🔒 Pago 100% seguro</span>
          <span data-id="element-136">⚡ Acceso en 5 minutos</span>
          <span data-id="element-137">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-138">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>
      </div>
    </section>;
}